import {
  Component, Input, ViewChild, ElementRef,
  transition, state, style, animate, trigger
} from '@angular/core';
import {OpenAPIService} from '../services/openapi';
import {UtilsService} from '../services/utils';
import {TrackerService} from '../services/tracker';

declare let window:any;

@Component({
    selector: 'api-call',
    templateUrl: '../views/api-call.pug',
    styles: [`
      api-response {
        display: block;
      }
      .parameters-title,
      .parameters-box {
        border: 1px solid #d9d9d9;
        padding: 15px;
        background-color: #f5f5f5;
      }
      :host >>> .parameters-box .well {
        background-color: #f5f5f5 !important;
      }
      .parameters-title {
        border-bottom: none;
        margin-bottom: -2px;
        background-color: #f5f5f5;
      }
      .parameters-box {
        border: 1px solid #d9d9d9;
        border-top: none;
        border-radius: 4px;
        margin-bottom: 20px;
        padding-top: 0px;
      }
    `],
    animations: [
      trigger('shrinkOut', [
        state('in', style({height: '*'})),
        transition('* => void', [
          style({height: '*', overflow: 'hidden'}),
          animate(0, style({height: 0}))
        ]),
        transition('void => *', [
          style({height: 0, overflow: 'hidden'}),
          animate(500, style({height: '*'}))
        ])
      ]),
    ],
})
export class APICallComponent {
  @Input() apiCall;
  @ViewChild('sampleCode') sampleCodeComponent;
  answers:any = {};
  executing:boolean;
  error:string;
  response:any;

  marked:Function = window.marked;

  constructor(public openapi:OpenAPIService,
              public utils:UtilsService,
              private tracker:TrackerService,
              private elementRef:ElementRef) {
  }

  ngOnInit() {
    setTimeout(() => window.app.appref.tick());  // FIXME: *ngIf="apiCallComponent" in docs view needs this.
  }

  ngOnChanges() {
    this.answers = {};
    this.response = null;
  }

  onInputChange() {
    if (this.sampleCodeComponent) this.sampleCodeComponent.refreshSampleCode();
  }

  execute() {
    if (!this.openapi.secrets.isAuthenticated(this.apiCall.operation)) {
      return this.openapi.secrets.startAuthentication();
    }
    this.tracker.track('api_call', {
      path: this.apiCall.path,
      method: this.apiCall.method,
    })
    this.error = null;
    this.executing = true;
    this.response = null;
    this.openapi.request({
      path:    this.apiCall.path,
      method:  this.apiCall.method,
      answers: this.answers,
    })
    .then((data, textStatus, xhr) => {
      this.response = {
        body: data,
        statusCode: xhr.status,
        headers: xhr.getAllResponseHeaders().split('\r\n'),
      };
      let type = window.checkResponse ? window.checkResponse(data, xhr.status).type : 'success';
      if (type !== 'success') type = 'failure';
      this.tracker.track('api_call_' + type, {
        status: xhr.status,
        path: this.apiCall.path,
        method: this.apiCall.method,
      });
    })
    .fail(xhr => {
      if (!xhr.status) {
        // Probably a CORS issue
        this.response = {
          body: "An unknown error occurred, possibly related to CORS. Check your browser's console for details.",
          statusCode: 0,
          headers: xhr.getAllResponseHeaders().split('\r\n'),
        }
      } else {
        this.response = {
          body: xhr.responseText,
          statusCode: xhr.status,
          headers: xhr.getAllResponseHeaders().split('\r\n'),
        }
      }
      this.tracker.track('api_call_failure', {
        status: xhr.status,
        path: this.apiCall.path,
        method: this.apiCall.method,
      });
    })
    .always(_ => {
      this.executing = false;
      setTimeout(() => {
        this.utils.scrollToSelection(window.jQuery(this.elementRef.nativeElement).find('api-response'));
      }, 100);
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/api-call.ts